<template>
  <div class="study">
    <div class="study-container">
      <div class="top-banner">

      </div>
      <div class="content">
        <van-sidebar v-model="activeKey" class="side-nav" @change="onChange">
          <van-sidebar-item
            v-for="item in categoryList"
            :key="item.id"
            :title="item.name" 
            class="nav-item"
          />
        </van-sidebar>
        <div class="event-list">
          <template v-if="eventList.length > 0">
            <div class="event-item" v-for="event in eventList" :key="event.id" @click="viewVideo(event)">
              <div class="item-header">
                <div class="item-category">{{ event.category.name }}</div>
                <div class="item-name">{{ event.name }}</div>
              </div>
              <div class="item-poster">
                <img :src="res_url + event.poster_img" />
              </div>
              <div class="item-info">
                <div>时长：{{event.duration}}</div>
                <div>发布时间：{{event.created_at}}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <van-empty description="暂无更多内容" />
          </template>
        </div>
      </div>
    </div>
    <van-popup v-model="showVideo" style="background: transparent">
    </van-popup>
    <Footer />
    <DisError />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import DisError from './component/DisError.vue';
import { mapState } from 'vuex'
import { categoryList, eventList } from '@/api/event';

export default {
  name: 'DisStudy',
  components: {
    Footer, DisError
  },
  data() {
    return {
      categoryLoading: false,
      eventLoading: false,
      activeKey: 0,
      categoryList: [],
      eventList: [],
      page: 1,
      limit: 100,
      videoUrl: '',
      showVideo: false,
    }
  },
  computed: {
    ...mapState(['user']),
    res_url() {
      return window.__config__.res_url;
    },
    categoryId() {
      if (this.activeKey in this.categoryList) {
        return this.categoryList[this.activeKey].id
      }
    }
  },
  watch: {
    categoryId: 'loadEvent',
    showVideo: function () {
      if (!this.showVideo) {
        this.videoUrl = ''
      }
    }
  },
  mounted() {
    this.initCategory();
  },
  methods: {
    initCategory() {
      categoryList().then(res => {
        // console.log('categoryList', res)
        this.categoryList = res.data;
      })
    },
    loadEvent() {
      this.eventLoading = true
      eventList({
        page: this.page,
        limit: this.limit,
        category_id: this.categoryId,
      }).then(res => {
        console.log('eventList', res)
        let list = 'data' in res.data ? res.data.data : [];
        let eventList = list //[].concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list).concat(list)
        this.eventList = eventList
        this.eventLoading = false
      })
    },
    viewVideo(event) {
      // this.videoUrl = window.__config__.video_url + event.video.file_key;
      // this.showVideo = true;
      this.$router.push('/DisEventDetail/' + event.id)
    },
    onChange(idx) {

    }
  }
}
</script>
<style lang="scss" scoped>
.study-container {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  .top-banner {
    height: 120px;
    flex: 0 0 120px;
    background: #333;
  }
  .content {
    flex: 1 1 auto;
    display: flex;
    overflow: hidden;
    background: #e3e3e3;
    .side-nav {
      height: 100%;
      max-width: 30vw;
      min-width: 120px;
      width: fit-content;
      background: #fff;
      flex-grow: 0;
      .nav-item {
      }
    }
    .event-list {
      width: 100%;
      // background: red;
      overflow-y: scroll;
      padding: 10px;
      .event-item {
        padding: 10px;
        background: #fff;
        width: 100%;
        border-radius: 10px;
        margin-bottom: 12px;

        .item-header {
          padding: 5px 0 10px 0;
          border-bottom: 1px solid #999;

          .item-category {
            display: inline-block;
            color: #fff;
            padding: 3px 10px;
            font-size: 13px;
            background: #5c9b73;
            border-radius: 3px;
          }
          .item-name {
            margin-top: 5px;
            font-size: 16px;
            font-weight: 400;
          }
        }
        
        .item-poster {
          width: 100%;
          img {
            width: 100%;
          }
        }
        .item-info {
          margin-top: 5px;
          color: #999;
          line-height: 1.8em;
        }
      }
    }
  }
}
.video_container {
  width: 90vw;
  height: 52vw;
  video {
    width: 100%;
  }
}
</style>
